import {
  CustomCell,
  CustomRenderer,
  GridCellKind,
} from "@glideapps/glide-data-grid";
import IAEnhanceButton from "../../Components/CargaPorTabla/IAEnhanceButton";
import { AiActivityEnhancementSystem } from "../../system/ai/AiActivityEnhancementSystem";
import { t } from "i18next";

export interface IAEnhanceButtonCellProps {
  readonly kind: "iaEnhanceButton-cell";
  readonly id: string;
  readonly item: any;
  readonly updateActivityNameAndDescription: (
    id: string,
    newNombreAct: string,
    newDescripcion: string
  ) => void;
  readonly aiActivityEnhancementSystem: AiActivityEnhancementSystem;
  readonly onWasGenerated: (wasGenerated: boolean) => void;
}

export type IAEnhanceButtonCell = CustomCell<IAEnhanceButtonCellProps>;

export const IAEnhanceButtonRenderer: CustomRenderer<IAEnhanceButtonCell> = {
  kind: GridCellKind.Custom,

  isMatch: (c): c is IAEnhanceButtonCell =>
    c.kind === GridCellKind.Custom &&
    (c.data as any).kind === "iaEnhanceButton-cell",

  draw: (args, cell) => {
    const { ctx, rect, theme } = args;

    ctx.save();
    ctx.beginPath();
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.clip();

    ctx.fillStyle = theme.textDark;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(`✨ ${t("Mejorar")}`, rect.x + rect.width / 2, rect.y + rect.height / 2);

    ctx.restore();
    return true;
  },

  provideEditor: () => {
    return (p) => {
      const { data } = p.value;

      return (
        <IAEnhanceButton
          item={data.item}
          aiActivityEnhancementSystem={data.aiActivityEnhancementSystem}
          updateActivityNameAndDescription={
            data.updateActivityNameAndDescription
          }
          onWasGenerated={data.onWasGenerated}
        />
      );
    };
  },
};
